import { DEFAULT_LANG_CODE, FREE_AND_PREVIEW_PLANS } from "../constants/constants";

export function displayCurrency(currencyCode) {
  return currencyCode === "INR" ? "₹" : currencyCode;
}

export function displayAmount(currencyCode, amount) {
  const localStringCode = currencyCode === "INR" ? "en-IN" : DEFAULT_LANG_CODE;
  return `${displayCurrency(currencyCode)}${(amount / 100).toLocaleString(localStringCode)}`;
}

export function formatSubscriptionStatus(status) {
  return status
    .split("_")
    .map((word) => word[0].toUpperCase() + word.substring(1))
    .join(" ");
}

export function planIdToString(planId) {
  if (FREE_AND_PREVIEW_PLANS.includes(planId)) {
    return "free-preview";
  }
  return planId.replace(/inr|jan|usd|2022/g, "").replace(/  +/g, " ");
}

export function dashCaseToSentenceCase(str) {
  return str.charAt(0).toUpperCase() + str.substr(1).split("-").join(" ");
}

